import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChartData, ProfitData, Top5Data } from '../../../models/admModel/dashboard.model';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Administrator Dashboard
// Component: DashboardComponent
// ----------------------------------------------

const ADDRS_API = config.API;

// API description for all commnication with BACK-END for systemlog events management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                          Actions                                             View
//  GET       api/adm/dash/chart            get chart data
//  GET       api/adm/dash/prof?scope=ss    get system profit where ss=TODAY/YESTERDAY/MONTH
//  GET       api/adm/dash/top5

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json',
                               'Access-Control-Allow-Origin': '*' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class DashboardService {
    constructor(private http: HttpClient) { }

    getDashboard(): Observable<any> {
      return this.http.get(ADDRS_API + `/admin/dashboard/global-statistics`)
    }
}
